import EmberObject, { get } from "@ember/object"
import { inject as service } from "@ember/service"
import ENV from "../config/environment"

export default class GoogleClassroomCardMediatorAdapter extends EmberObject {
  @service ajax

  find(ids = []) {
    return this.ajax.requestFromAdapter(
      ENV.API_ROOT + "/google_classroom_card_mediators/" + ids.join(",")
    )
  }
}
